import React, { ReactNode } from 'react'
import { cn } from '@bem-react/classname'
import { classnames as cx } from '@bem-react/classnames'

import './ButtonTg.scss'

interface IButtonTgProps {
  className?: string
  url: string
  children: ReactNode
}

const ButtonTg = ({ className, url, children }: IButtonTgProps) => {
  const buttonTg = cn('ButtonTg')

  return (
    <a
      className={cx(buttonTg(), className)}
      href={url}
      rel="noopener noreferrer"
    >
      {children}
    </a>
  )
}

export default ButtonTg
